import React from 'react';
import '../css/Shimmer.css';

// Base Shimmer Box
export const ShimmerBox = ({ width, height, borderRadius = '4px', className = '' }) => (
  <div
    className={`shimmer-box ${className}`}
    style={{ width, height, borderRadius }}
  />
);

// Shimmer for Stat Cards (4 cards row)
export const ShimmerStatCards = ({ count = 4 }) => (
  <div className="shimmer-stat-cards">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="shimmer-stat-card">
        <div className="shimmer-stat-content">
          <ShimmerBox width="100px" height="14px" />
          <ShimmerBox width="80px" height="28px" />
        </div>
        <ShimmerBox width="32px" height="32px" borderRadius="8px" />
      </div>
    ))}
  </div>
);

// Shimmer for Table
export const ShimmerTable = ({ rows = 5, columns = 5 }) => (
  <div className="shimmer-table-card">
    <div className="shimmer-table-header">
      {[...Array(columns)].map((_, i) => (
        <ShimmerBox key={i} width="100px" height="14px" />
      ))}
    </div>
    {[...Array(rows)].map((_, rowIndex) => (
      <div key={rowIndex} className="shimmer-table-row">
        {[...Array(columns)].map((_, colIndex) => (
          <ShimmerBox key={colIndex} width={colIndex === 0 ? "120px" : "80px"} height="14px" />
        ))}
      </div>
    ))}
  </div>
);

// Shimmer for Cards List (Driver list, Booking list)
export const ShimmerCardList = ({ count = 4 }) => (
  <div className="shimmer-card-list">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="shimmer-list-card">
        <div className="shimmer-list-card-left">
          <ShimmerBox width="48px" height="48px" borderRadius="50%" />
          <div className="shimmer-list-card-info">
            <ShimmerBox width="140px" height="16px" />
            <ShimmerBox width="100px" height="12px" />
          </div>
        </div>
        <ShimmerBox width="70px" height="28px" borderRadius="4px" />
      </div>
    ))}
  </div>
);

// Shimmer for Reviews
export const ShimmerReviews = ({ count = 3 }) => (
  <div className="shimmer-reviews-list">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="shimmer-review-card">
        <div className="shimmer-review-header">
          <ShimmerBox width="40px" height="40px" borderRadius="50%" />
          <div className="shimmer-review-info">
            <ShimmerBox width="120px" height="16px" />
            <ShimmerBox width="80px" height="12px" />
          </div>
          <ShimmerBox width="60px" height="16px" className="shimmer-ml-auto" />
        </div>
        <ShimmerBox width="100%" height="14px" />
        <ShimmerBox width="75%" height="14px" />
      </div>
    ))}
  </div>
);

// Shimmer for Chart Area
export const ShimmerChart = () => (
  <div className="shimmer-chart-card">
    <div className="shimmer-chart-header">
      <ShimmerBox width="180px" height="20px" />
      <ShimmerBox width="120px" height="14px" />
    </div>
    <div className="shimmer-chart-body">
      <div className="shimmer-bars">
        {[89, 172, 228, 124, 217, 162].map((height, i) => (
          <div key={i} className="shimmer-bar-item">
            <ShimmerBox width="100px" height={`${height}px`} borderRadius="3px 3px 0 0" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Shimmer for Services Orders sidebar
export const ShimmerServicesList = ({ count = 6 }) => (
  <div className="shimmer-services-card">
    <div className="shimmer-services-header">
      <ShimmerBox width="140px" height="18px" />
    </div>
    {[...Array(count)].map((_, i) => (
      <div key={i} className="shimmer-service-row">
        <ShimmerBox width="100px" height="14px" />
        <ShimmerBox width="40px" height="14px" />
      </div>
    ))}
  </div>
);

// Shimmer for Profile/Details Page
export const ShimmerProfile = () => (
  <div className="shimmer-profile">
    <div className="shimmer-profile-header">
      <ShimmerBox width="100px" height="100px" borderRadius="50%" />
      <div className="shimmer-profile-info">
        <ShimmerBox width="180px" height="24px" />
        <ShimmerBox width="140px" height="14px" />
        <ShimmerBox width="120px" height="14px" />
      </div>
    </div>
    <div className="shimmer-profile-details">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="shimmer-detail-row">
          <ShimmerBox width="100px" height="14px" />
          <ShimmerBox width="150px" height="14px" />
        </div>
      ))}
    </div>
  </div>
);

// Shimmer for Filter Section
export const ShimmerFilter = () => (
  <div className="shimmer-filter-card">
    <ShimmerBox width="180px" height="18px" />
    <div className="shimmer-filter-controls">
      <ShimmerBox width="150px" height="48px" borderRadius="8px" />
      <ShimmerBox width="150px" height="48px" borderRadius="8px" />
      <ShimmerBox width="120px" height="48px" borderRadius="8px" />
      <ShimmerBox width="120px" height="48px" borderRadius="8px" />
    </div>
  </div>
);

// Shimmer for Booking Details
export const ShimmerBookingDetails = () => (
  <div className="shimmer-booking-details">
    <div className="shimmer-booking-section">
      <ShimmerBox width="150px" height="20px" />
      <div className="shimmer-booking-info">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="shimmer-info-row">
            <ShimmerBox width="120px" height="14px" />
            <ShimmerBox width="180px" height="14px" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Shimmer for Document Types (Business Profile Step 2)
export const ShimmerDocumentTypes = ({ count = 6 }) => (
  <div className="shimmer-document-types">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="shimmer-document-item">
        <div className="shimmer-document-left">
          <ShimmerBox width="20px" height="20px" borderRadius="4px" />
          <ShimmerBox width={`${150 + Math.random() * 100}px`} height="16px" />
        </div>
      </div>
    ))}
  </div>
);

// Shimmer for Terms & Policies Content
export const ShimmerTermsContent = () => (
  <div className="shimmer-terms-content">
    <ShimmerBox width="60%" height="28px" className="shimmer-mb-16" />
    <ShimmerBox width="100%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="95%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="90%" height="16px" className="shimmer-mb-24" />

    <ShimmerBox width="45%" height="22px" className="shimmer-mb-12" />
    <ShimmerBox width="100%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="98%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="85%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="92%" height="16px" className="shimmer-mb-24" />

    <ShimmerBox width="50%" height="22px" className="shimmer-mb-12" />
    <ShimmerBox width="100%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="88%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="95%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="80%" height="16px" className="shimmer-mb-24" />

    <ShimmerBox width="40%" height="22px" className="shimmer-mb-12" />
    <ShimmerBox width="100%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="92%" height="16px" className="shimmer-mb-8" />
    <ShimmerBox width="97%" height="16px" />
  </div>
);

// Shimmer for Notifications List
export const ShimmerNotifications = ({ count = 5 }) => (
  <div className="shimmer-notifications-list">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="shimmer-notification-item">
        <ShimmerBox width="40px" height="40px" borderRadius="50%" />
        <div className="shimmer-notification-content">
          <ShimmerBox width="70%" height="14px" />
          <ShimmerBox width="90%" height="12px" />
          <ShimmerBox width="60px" height="10px" />
        </div>
      </div>
    ))}
  </div>
);

// Shimmer for Flash Sales Table
export const ShimmerFlashSales = ({ rows = 5 }) => (
  <div className="shimmer-table-card">
    {[...Array(rows)].map((_, i) => (
      <div key={i} className="shimmer-flash-row">
        {/* Offer */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="120px" height="15px" />
        </div>
        {/* From */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="90px" height="14px" />
          <ShimmerBox width="70px" height="12px" style={{ marginTop: 5 }} />
        </div>
        {/* To */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="90px" height="14px" />
          <ShimmerBox width="70px" height="12px" style={{ marginTop: 5 }} />
        </div>
        {/* Service */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="80px" height="14px" />
        </div>
        {/* Amount */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="100px" height="14px" />
          <ShimmerBox width="60px" height="12px" style={{ marginTop: 5 }} />
        </div>
        {/* Status */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="60px" height="14px" />
        </div>
        {/* Dots */}
        <div className="shimmer-flash-col">
          <ShimmerBox width="32px" height="32px" borderRadius="50%" />
        </div>
      </div>
    ))}
  </div>
);

export default {
  ShimmerBox,
  ShimmerStatCards,
  ShimmerTable,
  ShimmerCardList,
  ShimmerReviews,
  ShimmerChart,
  ShimmerServicesList,
  ShimmerProfile,
  ShimmerFilter,
  ShimmerBookingDetails,
  ShimmerDocumentTypes,
  ShimmerTermsContent,
  ShimmerNotifications,
  ShimmerFlashSales
};
